import api from "../api"

export const riskAPI = {
	async getAll() {
		let value = await api.get(`/riskdef/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async createRisk(TypeOfRisk, Rating1, Rating2, Rating3, Rating4, Rating5) {
		let value = await api.post(`/riskdef/`, {
			TypeOfRisk: TypeOfRisk,
			Rating1: Rating1,
			Rating2: Rating2,
			Rating3: Rating3,
			Rating4: Rating4,
			Rating5: Rating5,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}, async updateRiskById(ID, Rating1, Rating2, Rating3, Rating4, Rating5) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.put(`/riskdef/${ID}`, {
			Rating1: Rating1,
			Rating2: Rating2,
			Rating3: Rating3,
			Rating4: Rating4,
			Rating5: Rating5,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}, async deleteRisk(ID) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.delete(`/riskdef/${ID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return true
	}, async updateRiskprobById(ID, Description) {
		console.log("probability123:" ,ID,Description)
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.put(`/riskdef/${ID}/prob`, {
			Description: Description,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}, async getAllProbs() {
		let value = await api.get(`/riskprob/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	}, async saveAllProbs(Rating,Description) {
		console.log("Id ",Rating)
		let value = await api.post(`/riskprob/`,{
			Rating: Rating,
			Description: Description,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
}